import PrefixEnum from '../prefixes'

export default Object.freeze({
    'backinshape.gymondo.fitness': PrefixEnum.PAOLA,
})
